import React from "react";

const Table = ({hover, className, children}) => (
  <div className={`table ${className || ""} ${hover ? "hover" : ""}`}>{[children]}</div>
);

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table/index.jsx